import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const ShopLook = {
  shopLookContainers: document.querySelectorAll('[data-look-container]'),

  setLookSlider: function () {
    const { shopLookContainers, handlePinClick } = ShopLook;

    shopLookContainers.forEach((section) => {
      const swiperEl = section.querySelector('.swiper');
      const next = section.querySelector('.swiper-button-next');
      const prev = section.querySelector('.swiper-button-prev');

      if (swiperEl) {
        const carousel = new Swiper(swiperEl, {
          modules: [Navigation],
          slidesPerView: 1,
          spaceBetween: 8,
          watchOverflow: true,
          speed: 1000,
          navigation: {
            nextEl: next,
            prevEl: prev,
            disabledClass: '-disabled',
          },
        });

        handlePinClick(section, carousel);
      }
    });
  },

  // Troca de slide no carrossel de looks baseado na referencia de produto do pin clicado
  handlePinClick: function (section, carousel) {

    const pinContainer = section.querySelector('[data-pin-container]');
    if (!pinContainer) return;

    const pins = pinContainer.querySelectorAll('[data-pin-reference]');

    pins.length > 0 &&
      pins.forEach((pin) => {
        const productReference = pin.getAttribute('data-pin-reference');

        if (!productReference || !carousel?.el) return;

        const productSlide = carousel.el.querySelector(`[data-slide-product-reference="${productReference}"]`);
        if (!productReference) return;

        const productSlideIndex = Number(productSlide.getAttribute('data-slide-index')) ?? null;


        pin.addEventListener('click', () => {
          if (carousel.activeIndex === productSlideIndex) {
            productSlide.classList.add('-focus');
            setTimeout(() => {
              productSlide.classList.remove('-focus');
            }, 3000);
          } else {
            carousel.slideTo(productSlideIndex);
          }
        });
      });
  },

  init: function () {
    const { shopLookContainers, setLookSlider } = ShopLook;

    if (shopLookContainers.length > 0) {
      setLookSlider();
    }
  },
};

export default ShopLook;
